/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-04 16:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  handleCancel: () => void,
  handleDiscard: () => void
};

type ComposedProps = Props & WithI18nProps;

class ConfirmLeaveModal extends Component<ComposedProps> {
  render() {
    const { i18n, active } = this.props;

    return (
      <div>
        <Modal
          open={active}
          onClose={this.handleCancel}
          title={i18n.translate('AdminHTML.Common.ConfirmLeaveModal.title')}
          primaryAction={{
            content: i18n.translate('AdminHTML.Common.Action.leavePage'),
            onAction: this.handleDiscard,
            destructive: true
          }}
          secondaryActions={[
            {
              content: i18n.translate('AdminHTML.Common.Action.cancel'),
              onAction: this.handleCancel
            }
          ]}>
          <Modal.Section>
            <TextContainer>
              <TextStyle>{i18n.translate('AdminHTML.Common.ConfirmLeaveModal.content')}</TextStyle>
            </TextContainer>
            <div className="backdrop-custom" />
          </Modal.Section>
        </Modal>
      </div>
    );
  }

  // Handle click close button
  handleCancel = () => {
    this.props.handleCancel();
  };

  // Handle click  discard
  handleDiscard = () => {
    this.props.handleDiscard();
  };
}

export default withI18n()(ConfirmLeaveModal);
